<template>
  <el-row>
    <el-col :span="24">
      <el-card>
        <div slot="header" class="flex justify-between">
          <span>{{ $t('addMenuView.title') }}</span>
        </div>
        <el-form :model="addMenuViewInfo" label-width="120px">
          <el-form-item :label="$t('addMenuView.menuName')" required>
            <el-input
              v-model="addMenuViewInfo.name"
              :placeholder="$t('addMenuView.menuNamePlaceholder')"
              style="width: 100%">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('addMenuView.menuUrl')" required>
            <el-input
              v-model="addMenuViewInfo.url"
              :placeholder="$t('addMenuView.menuUrlPlaceholder')"
              style="width: 100%">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('addMenuView.seq')" required>
            <el-input
              v-model="addMenuViewInfo.seq"
              :placeholder="$t('addMenuView.seqPlaceholder')"
              style="width: 100%">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('addMenuView.menuShow')" required>
            <el-select
              v-model="addMenuViewInfo.isShow"
              style="width: 100%"
              :placeholder="$t('addMenuView.menuShowPlaceholder')">
              <el-option
                :label="$t('addMenuView.showMenu')"
                value="Y">
              </el-option>
              <el-option
                :label="$t('addMenuView.hideMenu')"
                value="N">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('addMenuView.description')">
            <el-input
              type="textarea"
              :rows="3"
              :placeholder="$t('addMenuView.descriptionPlaceholder')"
              v-model="addMenuViewInfo.description"
              style="width: 100%">
            </el-input>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'AddMenuView',
  props: {
    callBackListener: String,
    callBackFunction: String
  },
  data() {
    return {
      addMenuViewInfo: {
        flowComponent: 'addMenuView',
        name: '',
        url: '',
        seq: '',
        isShow: '',
        description: ''
      }
    }
  },
  watch: {
    addMenuViewInfo: {
      deep: true,
      handler(newVal) {
        console.log(newVal)
        this.saveAddMenuInfo()
      }
    }
  },
  methods: {
    saveAddMenuInfo() {
      if (this.validateForm()) {
        this.$emit(this.callBackFunction, this.addMenuViewInfo)
      }
    },
    validateForm() {
      if (!this.addMenuViewInfo.name) {
        this.$message.warning(this.$t('addMenuView.menuNameRequired'))
        return false
      }
      if (!this.addMenuViewInfo.url) {
        this.$message.warning(this.$t('addMenuView.menuUrlRequired'))
        return false
      }
      if (!this.addMenuViewInfo.seq) {
        this.$message.warning(this.$t('addMenuView.seqRequired'))
        return false
      }
      if (!this.addMenuViewInfo.isShow) {
        this.$message.warning(this.$t('addMenuView.menuShowRequired'))
        return false
      }
      return true
    },
    onIndex(index) {
      console.log(index)
      this.addMenuViewInfo.index = index
    }
  }
}
</script>

<style scoped>
.el-row, .el-col {
  width: 100%;
}
</style>